/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQOption } from './mCQOption';
import type { MCQQuestionExplanation } from './mCQQuestionExplanation';
import type { MCQQuestionDifficulty } from './mCQQuestionDifficulty';
import type { MCQQuestionImageUrl } from './mCQQuestionImageUrl';
import type { MCQQuestionImageAlt } from './mCQQuestionImageAlt';

/**
 * Generated MCQ question.
 */
export interface MCQQuestion {
  id: string;
  text: string;
  options: MCQOption[];
  explanation?: MCQQuestionExplanation;
  difficulty?: MCQQuestionDifficulty;
  imageUrl?: MCQQuestionImageUrl;
  imageAlt?: MCQQuestionImageAlt;
}
